<template>
  <section id="mission" class="hero is-large is-dark">
    <div class="hero-body">
        <div class="container">
            <div class="columns">
                <div class="column is-half">

                </div>
                <div class="column">
                    <h1 class="title is-h1">
                        My <span class="has-text-success">mission</span>
                    </h1>
                    <h2 id="mission-statement" class="subtitle has-text-grey-lighter">
                        To <span class="has-text-success has-text-weight-semibold">
                                improve quality of life
                            </span>
                        and <span class="has-text-success has-text-weight-semibold">
                                accelerate learning worldwide
                            </span>
                        by innovating at the cross-section between technologies
                    </h2>
                </div>
            </div>
        </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Mission',
  components: {},
};
</script>

<style lang="scss">
</style>
